<template>
  <div>
    <Frontendlayout>
      <section class="hero_in tours">
        <div class="wrapper">
          <div class="container">
            <h1 class="fadeInUp"><span></span>Domestic Travel Plan</h1>
          </div>
        </div>
      </section>
      <!--/hero_in-->
      <div class="container-fluid">
        <div class="row">
          <Sidebar />

          <div class="col-lg-10">
            <div class="box_general">
            <form @submit.prevent="searchJourney()" method="post">
              <div class="row">
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="category">Status</label>
                    <select
                      name=""
                      class="form-control"
                      id="category"
                      v-model="search.status"
                    >
                      <option value="">-Select-</option>
                      <option value="1">Active</option>
                      <option value="2">Inactive</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label>Journey With</label>

                    <select
                      v-model="search.journey_type"
                      class="form-control select2"
                    >
                      <option value="">-Select-</option>
                      <option value="friends">Friends</option>
                      <option value="family">Family</option>
                      <option value="self">Self</option>
                      <option value="couple">Couple</option>
                      <option value="other">Other</option>
                    </select>
                  </div>
                </div>
                <div class="col-lg-3">
                  <label>Travel From</label>
                  <vue-simple-suggest
                    v-model="search.from"
                    display-attribute="name"
                    value-attribute="url"
                    :list="getSuggestionList"
                  ></vue-simple-suggest>
                </div>
                <div class="col-lg-3">
                  <label>Travel To </label>
                  <vue-simple-suggest
                    v-model="search.to"
                    display-attribute="name"
                    value-attribute="url"
                    :list="getSuggestionLists"
                  ></vue-simple-suggest>
                </div>
                <div class="col-lg-5">
                  <label>Categories</label>
                  <select2-multiple-control
                    v-model="searchcat.categories"
                    :options="catOptions"
                    :settings="{
                      multiple: true,
                    }"
                    multiple
                    @select="catSelectEvent($event)"
                  />
                </div>

                <div class="col-lg-5">
                  <label>Sub Categories</label>
                  <select2-multiple-control
                    v-model="searchcat.subcategories"
                    :options="subCatOptions"
                    :settings="{ multiple: true }"
                    @select="subcatselectEvent($event)"
                    placeholder="-Select Categories-"
                  />
                </div>
                <div class="col-md-2">
                  <center>
                    <button type="submit" class="btn_1 add_top_30 mb-4">
                      Search
                    </button>
                  </center>
                </div>
              </div>
            </form>
            </div>
            <div class="row">
              <div class="col-lg-12">
                <router-link
                  class="btn btn-success pull-right mb-4"
                  to="/new-journey"
                  aria-expanded="false"
                >
                  <i class="fa fa-plus"></i>
                  <span class="nav-link-text">New Journey</span>
                </router-link>
              </div>
            </div>
            <div class="">
              <table
                id="dtBasicExample"
                class="table table-striped table-bordered table-sm"
                cellspacing="0"
                width="100%"
              >
                <thead>
                  <tr>
                    <th scope="col">Sno</th>
                    <th scope="col">Journey Name</th>
                    <th scope="col">From Date</th>
                    <th scope="col">To Date</th>
                    <th scope="col">Travelling From</th>
                    <th scope="col">Travelling To</th>
                    <th scope="col">Journey Type</th>
                    <th scope="col">Status</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(journey, index) in journeyList" :key="journey.id">
                    <td>{{ index + 1 }}</td>
                    <td>
                      {{ journey.journey_name }}<br />
                      <span
                        v-for="category in journey.categories"
                        :key="category.id"
                        >{{ category.category }}</span
                      >
                      <br />
                      <small
                        ><i>
                          <a
                            href=""
                            @click="redirect(journey.id, 'journey-categories')"
                            title="Add More/Remove Categories"
                          >
                            Add more</a
                          ></i
                        >
                      </small>
                    </td>
                    <td>{{ frontEndDateFormat(journey.from_date) }}</td>
                    <td>{{ frontEndDateFormat(journey.to_date) }}</td>
                    <td>{{ journey.travelling_from }}</td>
                    <td>{{ journey.travelling_to }}</td>
                    <td>{{ journey.journey_type }}</td>
                    <td>{{ journey.status == 2 ? "Inactive" : "Active" }}</td>

                    <td style="padding: 30px 0px">
                      <small
                        ><i>
                          <a
                            href=""
                            @click="redirect(journey.id, 'update-journey')"
                            title="Edit Journey"
                            ><i class="fa fa-edit"></i>Update</a
                          ></i
                        ></small
                      >
                      <span
                        class="badge badge-info"
                        v-for="destination in journey.destinations"
                        :key="destination.id"
                        >{{ destination.to_destination }}<br />
                        <small
                          >({{ frontEndDateFormat(destination.arrival_date) }}
                          to
                          {{
                            frontEndDateFormat(destination.departure_date)
                          }})</small
                        ></span
                      ><br />
                      <small
                        ><i>
                          <a
                            href=""
                            @click="
                              redirect(journey.id, 'add-destination-list')
                            "
                            title="Add New Destination"
                            ><i class="fa fa-plus"></i>Add new destination</a
                          ></i
                        ></small
                      >
                      <!--a href="#"><i class="fa fa-trash"></i></a-->
                    </td>
                  </tr>
                </tbody>
              </table>

              <!-- /cart-options -->
            </div>
          </div>
          <!-- /col -->
        </div>
        <!-- /row -->
      </div>
      <!-- /container -->

      <!-- /bg_color_1 -->
    </Frontendlayout>
  </div>
</template>

<script>
// import axios from 'axios'
// import Alert from "../cmps/Alert";
import API from "../services/index";
import moment from "moment";
import "jquery/dist/jquery.min.js";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import Frontendlayout from "@/layouts/Frontendlayout.vue";
import Sidebar from "@/layouts/Sidebar.vue";
import jQuery from "jquery";

export default {
  data() {
    return {
      searchcat: {
        categories: [],
        subcategories: [],
      },
      search: {
        from: "",
        to: "",
        journey_type: "",
        status: "",
      },
      catOptions: [],
      subCatOptions: [],
      journeyList: [],
      msg: null,
      roleId: localStorage.getItem("role_id"),
      to: "",
      from: "",
      journey_type: "",
      dt: null,
    };
  },
  watch: {
    journeyList() {
      this.dt.destroy();

      this.$nextTick(() => {
        this.dt = jQuery(".table").DataTable();
      });
    },
  },
  beforeMount() {
    this.getjourneyList(), this.checkToken();
    this.getParentCategories();
  },

  methods: {
    frontEndDateFormat(date) {
      //alert(date);
      return moment(date).format("DD/MM/YYYY hh:mm");
    },
    redirect(offerid, url) {
      //alert(offerid + " " + url);
      this.$router.push(url + "/" + window.btoa(offerid));
    },
    moment: function () {
      return moment();
    },

    getjourneyList() {
      const token = "Bearer " + localStorage.getItem("token");
      // alert(id);
      API.get("userjourney/journey_list", {
        headers: { Authorization: token },
      })
        .then((res) => {
          this.dt = jQuery(".table").DataTable();
          setTimeout(() => (this.journeyList = res.data));
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
    getParentCategories() {
      API.get("categories/parent_services_select2list")
        //.get("categories/parent_services")
        .then((res) => {
          this.catOptions = res.data.data;
          // this.search = this.search.categories;
          console.log(res.data.data);
        })
        .catch((err) => {
          console.log(err.response);
        });
    },

    searchJourney() {
      const token = "Bearer " + localStorage.getItem("token");

      const form = new FormData();
      form.append("search", JSON.stringify(this.search));
      form.append("categories", JSON.stringify(this.searchcat.categories));
      form.append(
        "subcategories",
        JSON.stringify(this.searchcat.subcategories)
      );
      API.post(`/Userjourney/search/roll`, form, {
        headers: { Authorization: token },
      })
        .then((res) => {
          if (res.data.status == 200) {
            this.dt = jQuery(".table").DataTable();

            setTimeout(() => (this.journeyList = res.data.data));
          } else {
            this.dt = jQuery(".table").DataTable();
            this.journeyList = res.data.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getSuggestionList() {
      var i = [];
      if (this.search.from.length >= 2) {
        return API.get(
          `https://location.securebrandtech.com/auto/api?q=${this.search.from}`
        )
          .then(function (response) {
            response.data.features.forEach(function (feature) {
              i.push(
                feature.properties.name +
                  " " +
                  feature.properties.county +
                  " " +
                  " " +
                  feature.properties.state +
                  " " +
                  feature.properties.postcode
              );
            });
            var uniq = [...new Set(i)];
            return uniq;
          })

          .catch(function (error) {
            console.log(error);
          });
      }
    },
     getSuggestionLists() {
      var i = [];
      if (this.search.to.length >= 2) {
        return API.get(
          `https://location.securebrandtech.com/auto/api?q=${this.search.to}`
        )
          .then(function (response) {
            response.data.features.forEach(function (feature) {
              i.push(
                feature.properties.name +
                  " " +
                  feature.properties.county +
                  " " +
                  " " +
                  feature.properties.state +
                  " " +
                  feature.properties.postcode
              );
            });
            var uniq = [...new Set(i)];
            return uniq;
          })

          .catch(function (error) {
            console.log(error);
          });
      }
    },
    setSubCategory(categoryId, mode) {
      //alert(categoryId);
      // let selSubCat = this.search.subcategories;
      API.get(
        "categories/parent_services_select2list/" + window.btoa(categoryId)
      )
        //.get("categories/parent_services")
        .then((res) => {
          if (mode == "push") {
            res.data.data.forEach((val) => {
              console.log("val=" + JSON.stringify(val));
              this.subCatOptions.push(val);
              //this.subCatOptions.concat(res.data.data);
            });

            //console.log("sub cat options=" + this.subCatOptions);
          } else {
            //this.search.subcategories.push(res.data.data);
            res.data.data.forEach((val) => {
              this.subCatOptions.splice(this.subCatOptions.indexOf(val.id), 1);
            });
          }
          this.searchcat.subcategories = [];
          // this.emitFilterRequest();
          //this.loadNearbyOffers(this.search);
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
    catSelectEvent(e) {
      var sel = e.selected;
      if (sel) {
        this.setSubCategory(e.id, "push");
        this.searchcat.categories.push(e.id);
      } else {
        this.setSubCategory(e.id, "remove");
        this.searchcat.categories.splice(
          this.searchcat.categories.indexOf(e.id),
          1
        );
      }
    },
    subcatselectEvent(e) {
      var sel = e.selected;
      //alert(sel + " " + e.id + " " + e.text + " " + e.selected);
      if (sel) {
        this.searchcat.subcategories.push(e.id);
      }

      //this.loadNearbyOffers(this.search);
    },

    checkToken() {
      const token = localStorage.getItem("token");
      // alert(token);
      if (token == null) {
        this.$router.push("/signin");
      }
    },
  },
  components: {
    Frontendlayout,
    Sidebar,
  },
};
</script>
<style  scoped>
@import "../../public/frontend/vendor/dropzone.css";

.journey {
  padding: 30px;
  background: #fff;
}
.fa {
  padding: 0 5px;
}

@media (max-width: 991px) {
  .table.cart-list td:nth-of-type(1):before,
  .table.cart-list td:nth-of-type(2):before,
  .table.cart-list td:nth-of-type(3):before,
  .table.cart-list td:nth-of-type(4):before,
  .table.cart-list td:nth-of-type(5):before,
  .table.cart-list td:nth-of-type(6):before {
    font-weight: 600;
    color: #111;
  }

  .table.cart-list td:nth-of-type(1):before {
    content: "Journey Name";
  }
  .table.cart-list td:nth-of-type(2):before {
    content: "Start Date";
  }

  .table.cart-list td:nth-of-type(3):before {
    content: "End Date";
  }

  .table.cart-list td:nth-of-type(4):before {
    content: "Travelling From";
  }

  .table.cart-list td:nth-of-type(5):before {
    content: "Travelling To";
  }

  .table.cart-list td:nth-of-type(6):before {
    content: "Journey type";
  }

  .table.cart-list td:nth-of-type(7):before {
    content: "Actions";
  }
}
</style>